// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--2Kqp9","containerGridItem":"style-module--container-grid-item--dRK7c","frame":"style-module--frame--2x0_b"};